export const IS_STAGING = window.location.href.includes("kideat.pl");

export const BASE_URL = (() => {
  if (import.meta.env.DEV) {
    return import.meta.env.VITE_AUTH_DEV_API_URL;
  }
  if (IS_STAGING) {
    return import.meta.env.VITE_AUTH_STAGE_API_URL;
  }
  return import.meta.env.VITE_AUTH_PROD_API_URL;
})();

export const APP_ORIGIN = window.location.origin;

export const TOKEN_COOKIE_NAME = "token";

// used in axios to comunicate with api
export const BASE_AUTH_URL = BASE_URL;
export const API_URL = `${BASE_URL}/api/frontend`;

export const DOMAIN = IS_STAGING ? "kideat.pl" : "obiado.pl";

// used to redirect to login page
export const LOGIN_URL = import.meta.env.DEV
  ? import.meta.env.VITE_LOGIN_DEV_URL
  : import.meta.env.VITE_PROD_AUTH_URL.replace("{domain}", DOMAIN);

export const IS_AUTH_BUILD_TARGET = import.meta.env.VITE_BUILD_TARGET === "auth";

const PROD_TENANT_URL_TEMPLATE = import.meta.env.VITE_TENANT_URL_TEMPLATE.replace(
  "{domain}",
  DOMAIN,
);

export const TENANT_URL_TEMPLATE = import.meta.env.DEV
  ? import.meta.env.VITE_TENANT_URL_DEV_TEMPLATE
  : PROD_TENANT_URL_TEMPLATE;

export const IS_QUCHENKA = window.location.href.includes("quchenka");
export const IS_RPK = window.location.href.includes("rpk.");
export const IS_POLKA = window.location.href.includes("polka");
export const IS_ZSP21 = window.location.href.includes("zsp21");
export const IS_DEVELOP =
  window.location.href.includes("localhost") || window.location.href.includes("127.0.0.1");
export const IS_SMACZNEGO = window.location.href.includes("smacznego");
export const IS_KASIA_GROUP = window.location.href.includes("kasiagroup");
export const CALENDAR_DAY_SINGLE_CLICK_THRESHOLD = 200;
export const TICKET_TYPES =
  !IS_POLKA && !IS_DEVELOP && !IS_STAGING
    ? ["complaints", "lunch_card", "meals", "releases", "orders", "technical_support", "other"]
    : [
        "meals_quality",
        "service_quality",
        "meals_availability",
        "lunch_card",
        "technical_support",
        "payments_and_settlements",
        "other",
      ];
export const TICKET_STATUSES = ["received", "sent", "closed"];

export const CRISP_WEBSITE_ID = "d3e38153-f263-496b-adda-c60370f563a5";

export const MAX_ITEMS_TO_EXPORT = 800;

export const TENANT_SLUG = import.meta.env.DEV
  ? import.meta.env.VITE_TENANT_SLUG
  : window.location.host.split(".")[0];

export const CLARITY_ENABLED = import.meta.env.VITE_CLARITY_ENABLED === "true";
